module.exports = __webpack_public_path__ + "static/media/warning-octagon-red.84e3f0e7.svg";